const BASE = "/api/agent/memory/items";

export async function listMemoryItems({ includeProposed = true, includeInactive = true, limit = 100 } = {}) {
  const params = new URLSearchParams({ include_proposed: String(includeProposed), include_inactive: String(includeInactive), limit: String(limit) });
  const response = await fetch(`${BASE}?${params}`, { credentials: "same-origin" });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || `HTTP ${response.status}`);
  }
  const body = await response.json();
  return Array.isArray(body.items) ? body.items : [];
}

export async function updateMemoryStatus({ memoryId, status }) {
  const response = await fetch(`${BASE}/${encodeURIComponent(String(memoryId))}`, {
    method: "PATCH",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || `HTTP ${response.status}`);
  }
  return response.json();
}
